// Bootstrap: mount the app. The audio engine starts only on the user's first
// Start click (handled inside App).
import "./styles.css";
import { App } from "./app.ts";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) {
  throw new Error("Loopfield: #app root element not found in index.html");
}

new App(root);
